(() => {
  const key = 'gw-product-return-v1';
  const safeProduct = (value) => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^\/products\/[a-z0-9-]+$/.test(url.pathname)) return null;
      const clean = new URL(url.pathname, location.origin);
      if (/^\d+$/.test(url.searchParams.get('variant') || '')) clean.searchParams.set('variant', url.searchParams.get('variant'));
      if (/^[a-f0-9]{64}$/.test(url.searchParams.get('gw_stock_request') || '')) clean.searchParams.set('gw_stock_request', url.searchParams.get('gw_stock_request'));
      return clean.pathname + clean.search;
    } catch { return null; }
  };
  const remember = () => {
    const path = safeProduct(location.href);
    if (path) { try { sessionStorage.setItem(key, path); } catch {} }
  };
  document.querySelectorAll('a[href="/collections/new-this-week"]').forEach((link) => { link.href = '/collections/new-this-week?sort_by=created-descending'; });
  remember();
  document.addEventListener('change', (event) => {
    if (event.target.matches('product-form input[name="id"]')) remember();
  });
  document.addEventListener('click', (event) => {
    const help = event.target.closest('[data-gw-context-help]');
    if (help) {
      const root = help.closest('product-info');
      const selected = root?.querySelector('variant-selects [data-selected-variant]');
      try {
        const variant = JSON.parse(selected?.textContent || 'null');
        const url = new URL(help.getAttribute('href'), location.origin);
        url.searchParams.set('product', root?.querySelector('h1')?.textContent.trim() || '');
        url.searchParams.set('url', new URL(root?.dataset.url || location.pathname, location.origin).href);
        const size = root?.querySelector('[name="properties[Requested ring size (US)]"]')?.value;
        url.searchParams.set('variant', [variant?.title, size ? 'Requested ring size (US): ' + size : ''].filter(Boolean).join(' · '));
        if (variant?.sku) url.searchParams.set('sku', variant.sku);
        help.href = url.pathname + url.search;
      } catch {}
    }
    const login = event.target.closest('[data-gw-login-return]');
    if (login) {
      remember();
      const path = safeProduct(location.href);
      if (path) { const url = new URL(login.href); url.searchParams.set(url.pathname === '/customer_authentication/login' ? 'return_to' : 'return_url', path); login.href = url.pathname + url.search; }
    }
    const newLink = event.target.closest('a[href="/collections/new-this-week"]');
    if (newLink) newLink.href = '/collections/new-this-week?sort_by=created-descending';
  });
  let saved;
  try { saved = safeProduct(new URLSearchParams(location.search).get('return_url') || sessionStorage.getItem(key) || ''); } catch {}
  if (saved) {
    document.querySelectorAll('[data-gw-return-context]').forEach((card) => {
      card.querySelector('[data-gw-return-link]').href = saved;
      card.hidden = false;
    });
    document.querySelectorAll('[data-gw-return-to]').forEach((field) => { field.value = saved; });
  }
})();
